module.exports = __webpack_public_path__ + "static/media/premierOneLeftSeatMobile.4f1f2171.svg";